import axios from "axios";
let token = process.env.MIX_API_KEY;
// axios.defaults.headers.common = {
//     Authorization: `Bearer ${token}`,
//     Accept: "application / json",
// };

axios.interceptors.request.use(function(config) {
    if (config) {
        // add X-CSRF-TOKEN header only if url begins with "/api/" or is on same domain
        if (config.url.includes(window.location.origin)) {
            config.headers["Authorization"] = `Bearer ${token}`;
            config.headers["Accept"] = "application/json";
        }
    }

    return config;
});

export default axios;
